module.exports = __webpack_public_path__ + "img/034.459ef01a.jpeg";